import { useEffect, useRef } from 'react';
import { handleSilentRenewCallback } from './utils/AuthService';

// This component is intended to be loaded inside a hidden iframe for OIDC silent renew.
// It must execute quickly and render nothing to avoid side effects.
export default function SilentRenewCallback() {
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    handleSilentRenewCallback();
  }, []);
  return null;
}
